import $ from 'jquery'
import 'select2'
import 'select2/dist/js/i18n/fr'
import 'select2/dist/css/select2.min.css'
import '@ttskch/select2-bootstrap4-theme/dist/select2-bootstrap4.min.css'
import { options } from "./config/select2";

$(() => {
    $('.select2').select2(options)
});